export default "__VITE_ASSET__CHxkmrlm__"